/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FlagComponent} from './flag.component';
import {TooltipModule} from '../tooltip/tooltip.module';

@NgModule({
    declarations: [FlagComponent],
    exports: [
        FlagComponent
    ],
    imports: [
        CommonModule,
        TooltipModule
    ]
})
export class FlagModule {
}
